import React from 'react'
import { clickableProps } from '../../utils/clickableProps'

const EventSelector = ({ userEvents, onEventSelect }) => {
  const unstampedEvents = userEvents.filter(event => !event.hasStamp)

  const handleEventSelect = (event) => {
    onEventSelect({
      id: event._id,
      name: event.name,
      description: event.description,
      venue: {
        name: event.venueName,
        city: event.country?.split(',')[0] || event.country || '',
        region: event.country?.split(',')[1]?.trim() || '',
        country: event.country || ''
      },
      dates: [{ datetime: event.startDate }],
      isUserEvent: true
    })
  }

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-white">
        Add a stamp to one of your existing events
      </h2>

      {unstampedEvents.length > 0 ? (
        <div className="space-y-4">
          <div className="grid gap-4">
            {unstampedEvents.map((event) => (
              <EventCard
                key={event._id}
                event={event}
                onClick={() => handleEventSelect(event)}
              />
            ))}
          </div>
        </div>
      ) : (
        <EmptyState />
      )}
    </div>
  )
}

const EventCard = ({ event, onClick }) => (
  <div
    className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 hover:bg-blue-500/20 transition-all duration-300 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
    {...clickableProps(onClick, `Add a stamp to ${event.name}`)}
  >
    <div className="flex justify-between items-start">
      <div>
        <h4 className="font-semibold mb-1 text-white">
          {event.name}
        </h4>
        <p className="text-sm mb-2 text-gray-300">
          {event.venueName} • {event.country}
        </p>
        <p className="text-sm text-gray-400">
          {event.description}
        </p>
      </div>
      <div className="text-right">
        <p className="text-sm text-gray-300">
          {new Date(event.startDate).toLocaleDateString()}
        </p>
      </div>
    </div>
  </div>
)

const EmptyState = () => (
  <div className="text-center py-8">
    <p className="text-lg mb-4 text-gray-300">
      You don't have any events without stamps yet.
    </p>
    <p className="text-sm text-gray-400">
      Add some events to your passport first, then come back here to add stamps.
    </p>
  </div>
)

export default EventSelector